import { useState } from 'react'
import Header from './Header'
import Footer from './Footer'

function AccordionItem({ title, children, isOpen, onClick, whatsappMsg }) {
  const waLink = `https://wa.me/+5491124089830?text=${encodeURIComponent(whatsappMsg)}`
  return (
    <div className="accordion-item-custom">
      <button
        className={`accordion-header-custom ${isOpen ? 'active' : ''}`}
        onClick={onClick}
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <i className={`bi ${isOpen ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
      </button>
      <div className={`accordion-body-custom ${isOpen ? 'open' : ''}`}>
        <div className="accordion-content-custom">
          {children}
          <div style={{marginTop: '15px'}}>
            <a href={waLink} className="cta-button cta-button-sm">Consultar por este servicio</a>
          </div>
        </div>
      </div>
    </div>
  )
}

function CiudadaniaItalianaServicios() {
  const [openIndex, setOpenIndex] = useState(null)

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <>
      <Header/>
      <main id="main">
        <section id="breadcrumbs" className="breadcrumbs">
          <div className="container">
            <ol>
              <li><a href="/">Inicio</a></li>
              <li><a href="/ciudadania-italiana">Ciudadanía italiana</a></li>
              <li>Servicios</li>
            </ol>
            <div className="section-title">
              <h3>Nuestros Servicios</h3>
            </div>
            <div className="accordion-custom">
              <AccordionItem
                title="Armado de carpeta para Consulado en CABA"
                isOpen={openIndex === 0}
                onClick={() => toggle(0)}
                whatsappMsg="Hola, quiero consultar por el armado de carpeta para Consulado en CABA para Ciudadanía Italiana"
              >
                <p>Nos encargamos de reunir, verificar y organizar toda la documentación necesaria para presentar ante el Consulado General de Italia en Buenos Aires. Durante todo el proceso, mantenemos al cliente debidamente informado sobre el estado de avance de su carpeta, garantizando una comunicación fluida y transparente en cada instancia del trámite.</p>
              </AccordionItem>

              <AccordionItem
                title="Apostillas y traducciones"
                isOpen={openIndex === 1}
                onClick={() => toggle(1)}
                whatsappMsg="Hola, quiero consultar por apostillas y traducciones para Ciudadanía Italiana"
              >
                <p>Gestionamos la apostilla de la documentación que lo requiera y realizamos las <strong>traducciones al italiano a cargo de traductor público matriculado</strong>, cumpliendo con los requisitos exigidos tanto por el Consulado como por las autoridades en Italia.</p>
                <p>Si ya tenés tu carpeta armada y solo necesitás apostillar o traducir, también podemos asistirte con este servicio de forma independiente.</p>
              </AccordionItem>

              <AccordionItem
                title="Gestiones en FAST IT"
                isOpen={openIndex === 2}
                onClick={() => toggle(2)}
                whatsappMsg="Hola, quiero consultar por gestiones en FAST IT para Ciudadanía Italiana"
              >
                <p>FAST IT es el portal del Ministerio de Relaciones Exteriores italiano a través del cual los ciudadanos italianos residentes en el exterior realizan sus gestiones consulares. Nos encargamos de:</p>
                <ul>
                  <li><i className="bi bi-check-circle" /> <strong>Inscripción en AIRE</strong> — registro obligatorio para todo ciudadano italiano que resida fuera de Italia por más de 12 meses</li>
                  <li><i className="bi bi-check-circle" /> <strong>Cambio de residencia</strong> — actualización de domicilio ante el Consulado correspondiente</li>
                  <li><i className="bi bi-check-circle" /> <strong>Actualización de estado civil</strong> — comunicación de matrimonio, divorcio u otros cambios</li>
                  <li><i className="bi bi-check-circle" /> <strong>Inscripción de menores</strong> — registro de hijos de ciudadanos italianos nacidos en el exterior (plazo especial hasta 31/05/2029)</li>
                </ul>
              </AccordionItem>

              <AccordionItem
                title="Legalizaciones"
                isOpen={openIndex === 3}
                onClick={() => toggle(3)}
                whatsappMsg="Hola, quiero consultar por legalización de sentencias para Ciudadanía Italiana"
              >
                <p>Realizamos la legalización de <strong>sentencias de divorcio y/o adopción</strong> emitidas por tribunales argentinos, dejándolas en condiciones de ser presentadas y reconocidas ante las autoridades italianas competentes.</p>
              </AccordionItem>

              <AccordionItem
                title="Búsqueda de actas en Italia"
                isOpen={openIndex === 4}
                onClick={() => toggle(4)}
                whatsappMsg="Hola, quiero consultar por búsqueda de actas en Italia para Ciudadanía Italiana"
              >
                <p>Gestionamos la solicitud de <strong>actas de nacimiento, matrimonio y defunción</strong> directamente ante las comunas italianas. Contamos con colaboradores en Italia que se encargan de las gestiones presenciales, resolviendo las dificultades de comunicación y los tiempos que suelen demorar estos trámites a distancia.</p>
              </AccordionItem>

              <AccordionItem
                title="Rectificación de actas"
                isOpen={openIndex === 5}
                onClick={() => toggle(5)}
                whatsappMsg="Hola, quiero consultar por rectificación de actas para Ciudadanía Italiana"
              >
                <p>Realizamos la corrección de errores en nombres, fechas u otros datos en actas argentinas que puedan trabar el avance de tu trámite, ya sea por <strong>vía administrativa o judicial en CABA</strong>. Una discrepancia menor en un acta puede frenar toda la carpeta; nos ocupamos de resolverlo.</p>
              </AccordionItem>

              <AccordionItem
                title="Asesoramiento pre-calificación"
                isOpen={openIndex === 6}
                onClick={() => toggle(6)}
                whatsappMsg="Hola, quiero consultar por asesoramiento pre-calificación para Ciudadanía Italiana"
              >
                <p>Antes de iniciar cualquier gestión, analizamos tu <strong>árbol genealógico</strong> para determinar si calificás bajo los requisitos de la Ley 74/2025. Esto te permite saber desde el inicio si estás en condiciones de acceder al reconocimiento, evitando invertir tiempo y dinero en un trámite que no prospere.</p>
              </AccordionItem>

              <AccordionItem
                title="Gestión de pasaporte italiano"
                isOpen={openIndex === 7}
                onClick={() => toggle(7)}
                whatsappMsg="Hola, quiero consultar por gestión de pasaporte italiano"
              >
                <p>Una vez reconocida tu ciudadanía, te asistimos en la <strong>obtención del pasaporte italiano</strong>: gestionamos el turno y te acompañamos en la presentación ante el Consulado en CABA.</p>
              </AccordionItem>

              <AccordionItem
                title="Certificado de no naturalización"
                isOpen={openIndex === 8}
                onClick={() => toggle(8)}
                whatsappMsg="Hola, quiero consultar por certificado de no naturalización para Ciudadanía Italiana"
              >
                <p>Tramitamos el <strong>certificado de no naturalización</strong> ante la Cámara Nacional Electoral, documento que acredita que tu ancestro italiano no adquirió la ciudadanía argentina — o que lo hizo con posterioridad al nacimiento de su hijo. Es un requisito fundamental para la carpeta consular.</p>
              </AccordionItem>
            </div>

            <div className="text-center" style={{marginTop: '40px'}}>
              <p><strong>Tu ciudadanía con respaldo legal.</strong> Escribinos y te orientamos según tu caso.</p>
              <a href="https://wa.me/+5491124089830?text=Hola%2C%20quiero%20consultar%20por%20ciudadan%C3%ADa%20italiana" className="cta-button">Quiero iniciar mi trámite</a>
            </div>
          </div>
        </section>
      </main>
      <Footer/>

      <style>{`
        .accordion-custom {
          max-width: 800px;
          margin: 0 auto;
        }
        .accordion-item-custom {
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          margin-bottom: 12px;
          overflow: hidden;
          transition: box-shadow 0.3s ease;
        }
        .accordion-item-custom:hover {
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
        }
        .accordion-header-custom {
          width: 100%;
          padding: 18px 24px;
          background: #fff;
          border: none;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 1.05rem;
          font-weight: 600;
          color: #2c2c2c;
          transition: background 0.2s ease;
        }
        .accordion-header-custom:hover {
          background: #fafafa;
        }
        .accordion-header-custom.active {
          background: #b41e1e;
          color: #fff;
        }
        .accordion-header-custom.active i {
          color: #fff;
        }
        .accordion-header-custom i {
          font-size: 1.1rem;
          color: #b41e1e;
          transition: transform 0.3s ease;
        }
        .accordion-body-custom {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.4s ease;
        }
        .accordion-body-custom.open {
          max-height: 600px;
        }
        .accordion-content-custom {
          padding: 20px 24px;
          border-top: 1px solid #eee;
        }
        .accordion-content-custom p {
          font-size: 0.98rem;
          color: #555;
          line-height: 1.7;
          text-align: justify;
          margin-bottom: 10px;
        }
        .accordion-content-custom ul {
          list-style: none;
          padding: 0;
        }
        .accordion-content-custom ul li {
          padding: 6px 0;
          font-size: 0.95rem;
          color: #555;
        }
        .accordion-content-custom ul li i {
          color: #b41e1e;
          margin-right: 8px;
        }
        .cta-button-sm {
          font-size: 0.85rem;
          padding: 10px 20px;
        }
      `}</style>
    </>
  )
}

export default CiudadaniaItalianaServicios;
